
<ng-container *ngIf="isLoaded">
  <div style="text-align: right; font-size: 17px; margin-right: 20px; margin-top: 5px; font-weight: 600 " (click)="closeModal()" >X</div>
  <div class="card-body m-3">
    <div class="pt-4 pb-2">
      <h5 class="card-title text-center pb-0 fs-4">Разпределение на Приходи</h5>
      <p class="text-center small">моля прегледайте списъка с всичи <b>сметки</b> от страна на доставчика на услуга, както и услугите които ще бъдат
      разпределени по споменатите сметки, преди генериране на платежно.</p>
    </div>
    <div class="row" style="display:flexl; flex-flow:row; align-items:end;width:100%">
      <!-- mb-3 for margin bottom -->


      <!--<div style="width:60%">
        <label class="form-label">Към Бюджетна Сметка</label>
        <select [(ngModel)]="selectedBankAccount" (change)="onBankAccountChange(selectedBankAccount)" class="form-select">
          <option *ngFor="let option of deliveryServiceOptions" [ngValue]="option.bankAccount">
            {{ option.bankAccount }} ({{ option.serviceName }})
          </option>
        </select>
      </div>-->
      <div>
        <button *ngIf="deliveryServiceOptions && deliveryServiceOptions.length>0" type="button" class="btn btn-primary"
                (click)="createSettlement()">
          Създай
        </button>
      </div>
    </div>
    <div class="card-body">
      <ng-container *ngIf="deliveryServiceOptions && deliveryServiceOptions.length>0">
        <div ngbAccordion *ngFor="let ds of deliveryServiceOptions;index as i" #acc="ngbAccordion" [closeOthers]="true">
          <div ngbAccordionItem id="static-{{i}}" title="{{ ds.bankAccount }} ({{ ds.serviceName }})">
            <ng-template ngbPanelContent>
              <div>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Имена на Заявителя</th>
                      <th scope="col">Заявена Услуга</th>
                      <th scope="col">Заплатена Такса</th>
                    </tr>
                  </thead>
                  <tr *ngFor="let request of filterServiceRequestsByIndex(i)">
                    <td>{{ request.firstName }} {{ request.fammily }}</td>
                    <td>{{ getServiceName(request) }}</td>
                    <td>{{ request.serviceProviderTax }} лв.</td>
                    <!-- Add other service request details here -->
                  </tr>
                </table>
              </div>
            </ng-template>
          </div>

        </div>
      </ng-container>
      <ng-container *ngIf="!deliveryServiceOptions || deliveryServiceOptions.length==0">
        <div style="text-align: center; font-size: 18px; font-weight: 600; ">Няма суми за разпределение на Текущата организация.</div>
      </ng-container>
    </div>
  </div>

</ng-container>
